'use strict';

exports.__esModule = true;
exports.default = createSplitLink;

var _apolloBoost = require('apollo-boost');

var _apolloUtilities = require('apollo-utilities');

function createSplitLink(socketLink, httpLink) {
  return _apolloBoost.ApolloLink.split(hasSubscription, socketLink, httpLink);
}

function hasSubscription(_ref) {
  var query = _ref.query;

  var _getMainDefinition = (0, _apolloUtilities.getMainDefinition)(query),
      kind = _getMainDefinition.kind,
      operation = _getMainDefinition.operation;

  return kind === 'OperationDefinition' && operation === 'subscription';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/graph-client/link-split.js
// module id = 1134
// module chunks = 0